<template>
  <div class="row position-relative align-items-center follow-btn-cta">
    <div class="col-auto text-center">
      <FollowBtn
        v-if="showFollowButton"
        :model="model"
        class="mx-2"
        follow-class="btn-primary"
        hover-class="btn-secondary"
        unfollow-class="unfolow-btn"
      />
    </div>
    <div
      class="additional-actions-wrapper col-auto position-absolute d-flex justify-content-end align-items-center"
    >
      <ConversationButton />
      <span
        class="playhera-icon mx-4 cursor-pointer"
        @click.prevent="
          $event =>
            openSharingMenu({
              event: $event,
              type: account._type,
              text: `${$filters.displayName(account)} ${$t(
                '_web_' + account._type,
                account._type
              )} on `,
              id: account._id,
              vanityId: account.vanityId,
            })
        "
      >
        <AppIcon name="share" />
      </span>
      <button
        type="button"
        class="btn-transparent p-2 cursor-pointer text-secondary"
        @click="setActionPopover($event)"
      >
        <AppIcon name="dots" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import actions from '@/mixins/accountActions/profile';
import FollowBtn from '@/components/common/NewFollowBtn';
import ConversationButton from '@/views/account/header/statusBar/default/ConversationButton';
import AppIcon from '@/components/atoms/Icon';
import { sharingMenu } from '@/mixins/sharingMenu';
import AccountModel from '@/models/Account';
import { API } from '@/api/config';

export default {
  name: 'AccountStatusBarActionsOrganization',
  components: {
    ConversationButton,
    FollowBtn,
    AppIcon,
  },
  mixins: [...actions, sharingMenu],
  data() {
    return {
      actionPopoverPosition: null,
      blockUserLoading: false,
      isUserBlocked: false,
      model: new AccountModel(),
      showFollowButton: false,
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccount: 'account' }),
  },
  created() {
    this.getIsBlockedAccountInfo();
    this.getPostAuthorProfile(this.account.login);
  },
  methods: {
    ...mapActions({
      openPopoverMenu: 'popoverMenu/open',
    }),
    ...mapActions([
      'getAccountBlockedBy',
      'blockAccount',
      'closeModal',
      'openModal',
      'errorNotify',
    ]),
    async getPostAuthorProfile(id) {
      const response = await API(`/profiles/${id}`);
      this.model = new AccountModel(
        response.data.type,
        response.data.login
      ).update(response.data);
      this.showFollowButton = true;
    },
    blockAccountAction() {
      this.blockUserLoading = true;
      this.blockAccount({
        accountType: this.account._type,
        accountId: this.accountId,
      })
        .then(() => {
          this.closeModal();
          this.$emit('authorBlocked');
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.blockUserLoading = false;
        });
    },
    openBlockConfirm() {
      return this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_profile_block_user_request',
            'Are you sure you want to block {name}? All content from this account will be hidden',
            {
              name: this.$filters.displayName(this.account),
            }
          ),
          cancelButtonText: this.$t('_web_post_delete-cancel', 'Cancel'),
          confirmButtonText: this.$t('_web_post_block-confirm', 'Yes, block'),
          isLoading: this.blockUserLoading,
        },
        events: {
          cancel: this.closeModal,
          confirm: this.blockAccountAction,
        },
        options: {
          clickOnBackdrop: false,
          escKey: false,
        },
      });
    },
    getIsBlockedAccountInfo() {
      this.isLoading = true;
      this.getAccountBlockedBy({
        accountType: this.account._type,
        accountId: this.accountId,
      })
        .then(res => {
          res.map(profile => {
            if (profile === this.myAccount.login) this.isUserBlocked = true;
          });
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.isLoading = false;
        });
    },
    setActionPopover(event) {
      const items = [
        {
          label: this.isUserBlocked
            ? this.$t('_web_user-is-blocked', '{name} is blocked', {
                name: this.$filters.displayName(this.account),
              })
            : this.$t('_web_post_block-user', 'Block {name}', {
                name: this.$filters.displayName(this.account),
              }),
          action: this.isUserBlocked ? null : this.openBlockConfirm,
          loading: this.blockUserLoading,
        },
      ];
      this.openPopoverMenu({
        event,
        settings: {
          stopItemClickBubbling: true,
          isFixed: false,
          autoClose: true,
          targetSelector: 'svg',
        },
        items,
      });
    },
  },
};
</script>

<style lang="scss">
.follow-btn-cta {
  justify-content: center;
}
.additional-actions-wrapper {
  @include auto-rtl(right, 0);
}
@media screen and (max-width: 767px) {
  .follow-btn-cta {
    justify-content: start;
  }
}
</style>
